<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <!-- <md-button
              @click="previousFFView"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
          ><md-icon icon="bell-fill" class="border rounded p-2">edit</md-icon></md-button>-->
          <b-navbar-brand center>AMS Filling</b-navbar-brand>
        </b-navbar>
        <!-- <banner-component
          :allModuleIdBanner="this.allData.BLSeries"
          :jobSeriesBanner="this.allData.BLSeries"
          :bannerClientName="this.allData.clientName"
          iconId="fa fa-ship"
        /> -->
        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter>
           
              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>Master B/L Number</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="linerBLNumber"
                    name="linerBLNumber"
                    v-model="amsMainModel.blNumber"
                    :disabled="amsMainModel.blType=='liner'"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!amsMainModel.blNumber">{{erroramsMainModel.blNumber}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <md-input-container>
                  <label>Upload B/L</label>
                  <md-file
                    name="uploadMasterBL"
                    id="uploadMasterBL"
                    v-model="amsMainModel.uploadMasterBL"
                    @selected="onFileChangelinerBL"
                    multiple
                    :disabled="amsMainModel.blType=='liner'"
                  ></md-file>
                </md-input-container>

                <span
                  class="error"
                  v-if="!amsMainModel.uploadMasterBL"
                >{{erroramsMainModel.uploadMasterBL}}</span>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
             v-if="uploadBookingStatus.length >0"
            >
              <md-layout md-flex="50"></md-layout>
              <md-layout md-flex="35" v-for="(item,index) in uploadBookingStatus" :key="index">
                <!-- :href="'http://13.229.240.246/LinerBLCon/'+item" -->
                <a
                  :href="`${docURL}/FF_Sea_Export_Uploads/`+item"
                  target="_blank"
                  download
                >View Document - {{index+1}}</a>
              </md-layout>
            </md-layout>

           

            <md-layout md-gutter class="labelMargtop">
            

              <md-layout md-flex="45">
                <label
                  for="amsFiling"
                >{{(this.amsMainModel.blType=='liner')?'(Liner-BL)':'(House-BL)'}} AMS Filing To be Done</label>
                <model-list-select
                  :list="blTypeList"
                  v-model="amsMainModel.amsFiling"
                  option-value="blTypeVal"
                  option-text="blTypeTxt"
                  placeholder="Select AMS Filing "
                  :isDisabled="amsTableArry.length>0"
                ></model-list-select>
                <span class="error" v-if="!amsMainModel.amsFiling">{{erroramsMainModel.amsFiling}}</span>
              </md-layout>
              </md-layout>
           <md-layout md-gutter class="mt-1">

              <md-layout
                md-flex="30"
                v-if="amsMainModel.portLocationType=='USA'"
               
              >
                <md-checkbox
                  id="my-test5"
                  name="my-test5"
                  v-model="amsMainModel.isCheckUSA"
                  class="md-primary"
                  md-value="checked"
                >AMS Against HBL (PRIDEL Fling)</md-checkbox>
              </md-layout>
            </md-layout>
       
              <b-card class="mt-2" style="background:whiteSmoke" v-if="amsMainModel.amsFiling=='Yes'">
                <md-layout md-gutter class="gutr" v-if="amsMainModel.amsFiling=='Yes'">
                

                  <md-layout md-flex="40" v-if="amsMainModel.amsFiling=='Yes'">
                    <h5>
                      <b-badge>ADVANCE CARGO DECLARATION(ACD)</b-badge>
                    </h5>
                  </md-layout>
                  <md-layout md-flex="90"></md-layout>
                  <md-layout md-flex="10" v-if="amsFiligModal.amsffNormalId!=''">
                    <b-button
                      variant="warning"
                      size="sm"
                      id="addButtonLoaderpre"
                      @click="Print"
                    >ACD PDF</b-button>
                    <md-spinner md-indeterminate id="loaderpre" style="display:none"></md-spinner>
                  </md-layout>
                </md-layout>
                <div v-if="amsMainModel.amsFiling=='Yes'">
                  <md-layout md-gutter class="labelMargtop">
                  
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label for="clientName">Client Name</label>

                        <b-form-input :formatter="capitalizeAll" v-model="amsFiligModal.clientName" disabled></b-form-input>
                      </md-layout>
                      <span
                        class="error"
                        v-if="!amsFiligModal.fclConsoMultipleClientId"
                      >{{errorconFclBLNonUsId}}</span>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                  
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Vessel Name</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="vesselName"
                          name="vesselName"
                          v-model="amsFiligModal.vesselName"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                   
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Place of Origin</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="placeOrigin"
                          name="placeOrigin"
                          v-model="amsFiligModal.placeOrigin"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Port of Loading</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="loadingPort"
                          name="loadingPort"
                          v-model="amsFiligModal.loadingPort"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="labelMargtop">
                  
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Port of Discharge</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="dischargePort"
                          name="dischargePort"
                          v-model="amsFiligModal.dischargePort"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Final Delivery Place With ZIP Code</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="finalDeliveryWithZip"
                          name="finalDeliveryWithZip"
                          v-model="amsFiligModal.finalDeliveryWithZip"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="labelMargtop">
                  
                    <md-layout md-flex="45">
                      <label>Actual Shipper Address with Ctc</label>
                      <quill-editor
                      style="width:100% !important"
                        ref="myTextEditor"
                        v-model="amsFiligModal.shipperAddrWithCtc"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="50">
                      <label>Consignee Name Address with Tel.& FAX No.</label>
                      <quill-editor
                       style="width:100% !important"
                        ref="myTextEditor"
                        v-model="amsFiligModal.ConsigneeNameAddrs"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="labelMargtop">
                   
                    <md-layout md-flex="45">
                      <label>Cargo Description With 6 Digit Harmonized Code with No. Of Cartons / Pellets</label>
                      <quill-editor
                       style="width:100% !important"
                        ref="myTextEditor"
                        v-model="amsFiligModal.cargoDescription"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <label>Cargo Gross Weight</label>
                      <quill-editor
                       style="width:100% !important"
                        ref="myTextEditor"
                        v-model="amsFiligModal.cargoGrossWeight"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                        <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <label>Cargo Net Weight</label>
                      <quill-editor
                         style="width:100% !important"
                        ref="myTextEditor"
                        v-model="amsFiligModal.cargoNetWeight"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                
                    <md-layout md-flex="45">
                      <label>Container No.</label>
                      <quill-editor
                         style="width:100% !important"
                        ref="myTextEditor"
                        v-model="amsFiligModal.containerNo"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="50">
                      <label>Seal No</label>
                      <quill-editor
                         style="width:100% !important"
                        ref="myTextEditor"
                        v-model="amsFiligModal.sealNo"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                 
                    <md-layout md-flex="100">
                      <label>Declaration</label>
                      <quill-editor
                        ref="myTextEditor"
                         style="width:100% !important"
                        v-model="amsFiligModal.declaration"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                   
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>For</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="declarationFor"
                          name="declarationFor"
                          v-model="amsFiligModal.declarationFor"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <label>Date</label>
                      <date-picker
                      :format="selectDateFormat"
                        lang="en"
                        id="declarationDate"
                        name="declarationDate"
                        v-model="amsFiligModal.declarationDate"
                      ></date-picker>
                    </md-layout>
                  </md-layout>
                </div>

                <md-layout md-gutter v-if="amsMainModel.blType=='liner'" class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="25">
                    <label
                      for="isIsfFiling"
                    >{{(this.amsMainModel.blType=='liner'?'(Liner-BL)':this.amsMainModel.blType)}} ISF Filing To be Done</label>
                    <model-list-select
                      :list="blTypeListISF"
                      v-model="amsMainModel.isIsfFiling"
                      option-value="blTypeIsfVal"
                      option-text="blTypeIsfTxt"
                      placeholder="Select ISF Filing "
                    ></model-list-select>
                  </md-layout>
                </md-layout>
              </b-card>
        
            <md-layout md-gutter v-if="amsMainModel.isIsfFiling=='Yes'">
              <md-layout md-flex="5"></md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr ">
            
              <md-layout md-flex="20">
                <b-button
                class="mt-3"
                  variant="primary"
                  id="addButtonLoaderSubmit"
                  @click="addNormalFFAms('')"
                >Save & Submit</b-button>
                <md-spinner md-indeterminate id="loaderSubmit" style="display:none"></md-spinner>
              </md-layout>
              <!-- <md-layout md-flex="25"></md-layout>
              <md-layout md-flex="15" v-if="amsFiligModal.amsffNormalId!=''">
                <md-button
                  class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                  id="addButtonLoaderpre"
                  @click="Print"
                >Print ACD</md-button>
                <md-spinner md-indeterminate id="loaderpre" style="display:none"></md-spinner>
              </md-layout>-->
            </md-layout>

            <md-layout md-gutter>
            

              <md-layout
                md-flex="25"
                v-if="(amsMainModel.portLocationType=='USA' && amsMainModel.blType=='house') || amsMainModel.isIsfFiling=='Yes'"
              >
                <b-button
                class="mt-1"
                  variant="primary"
                  id="addButtonLoaderIFS"
                  @click="addNormalFFAms('fdf')"
                >Proceed To IFS Form</b-button>
                <md-spinner md-indeterminate id="loaderIFS" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopBL"
      @close="oncloseBL"
    ></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/freightForward/amsFilingNormal"
      );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,

      blTypeList: [
        {
          blTypeVal: "Yes",
          blTypeTxt: "Yes"
        },
        {
          blTypeVal: "No",
          blTypeTxt: "No"
        }
      ],
      blTypeListISF: [
        {
          blTypeIsfVal: "Yes",
          blTypeIsfTxt: "Yes"
        },
        {
          blTypeIsfVal: "No",
          blTypeIsfTxt: "No"
        }
      ],

      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      getCLientData: [],
      getContainerArry: [],
      amsTableArry: [],
      mainExportData: [],

      amsFiligModal: {
        amsffNormalId: "",
        fclConsoMultipleClientId: "",
        clientName: "",
        clientId: "",
        vesselName: "",
        placeOrigin: "",
        loadingPort: "",
        dischargePort: "",
        finalDeliveryWithZip: "",
        shipperAddrWithCtc: "",
        ConsigneeNameAddrs: "",
        cargoDescription: "",
        cargoGrossWeight: "",
        cargoNetWeight: "",
        containerNo: "",
        sealNo: "",
        declaration:
          "We hereby indemnify the carrier Mediterranean Shipping Company on any claims / loss for any misdeclaration of the above information and all costs and consequences arising out of the shipment is on our (shipper's) account.",
        declarationFor: "",
        declarationDate: "",
        uploadAcd: ""
      },
      erroramsMainModel: {
        blNumber: "",
        uploadMasterBL: "",
        amsFiling: ""
      },

      arrayErroramsMainModel: {
        blNumber: "Enter BL Number",
        uploadMasterBL: "Upload Master BL",
        amsFiling: "Select Ams Filing"
      },
      errorconFclBLNonUsId: "",
      amsMainModel: {
        amsNormalMainId: "",
        portLocationType: "",
        blNumber: "",
        uploadMasterBL: "",
        blType: this.$sessionsStorage.get("blType"),
        ffType: "fclNormal",
        isCheckUSA: "",

        amsFiling: "",
        ExportId: "",
        ExecutionId: "",
        BookingId: "",
        isIsfFiling: ""
      },

      validate: true
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  watch: {},
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
     CustomLoader,
    BannerComponent
  },

  computed: {
    uploadBookingStatus() {
      return this.amsMainModel.uploadMasterBL != null
        ? this.amsMainModel.uploadMasterBL.split(",")
        : [];
    },
    clientList() {
      return this.getCLientData;
    }
  },

  methods: {
    Print() {
      window.open(
        `${this.docURL}/AMSFILING_ACD_SEA_EXPORT_PDF/` + this.amsFiligModal.uploadAcd
      );
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    oncloseBL() {},
    getData() {
      this.doLoading();
      let new_data = {
        blType: this.$sessionsStorage.get("blType")
      };

      new_data["ExportId"] = this.$sessionsStorage.get("editExportFCLId");
      new_data["ExecutionId"] = this.$sessionsStorage.get("editFFExecutionId");

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToNormalAmsFiling.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          console.log(data)
          if ( status == 200 && data) {
            if (data.BLData.length > 0) {
              this.allData = data.BLData[0];
              this.amsMainModel.portLocationType =
                data.BLData[0].portLocationType;
            }

            if (data.amsMainData.length > 0) {
              Object.keys(this.amsMainModel).map(x => {
                this.amsMainModel[x] = data.amsMainData[0][x] || "";
              });
            } else {
              if (data.blLandingData.length > 0) {
                this.amsMainModel.uploadMasterBL =
                  data.blLandingData[0].linerBLupload;
                this.amsMainModel.blNumber =
                  data.blLandingData[0].linerBLNumber;
              }
            }

            if (data.amsData.length > 0) {
              Object.keys(this.amsFiligModal).map(x => {
                this.amsFiligModal[x] = data.amsData[0][x] || "";
              });
            } else {
              if (data.BLData.length > 0) {
                this.amsFiligModal.finalDeliveryWithZip =
                  data.BLData[0].placeDilievery;
                this.amsFiligModal.dischargePort = data.BLData[0].portDischarge;
                this.amsFiligModal.loadingPort = data.BLData[0].portLoad;

                this.amsFiligModal.placeOrigin = data.BLData[0].pointofOrigin;
                this.amsFiligModal.shipperAddrWithCtc =
                  data.BLData[0].corporateAddress;
                this.amsFiligModal.ConsigneeNameAddrs =
                  data.BLData[0].consignee;
                this.amsFiligModal.cargoGrossWeight =
                  data.BLData[0].grossWeight;
                this.amsFiligModal.cargoNetWeight = data.BLData[0].netWeight;
                this.amsFiligModal.clientName = data.BLData[0].clientName;
                this.amsFiligModal.clientId = data.BLData[0].clientId;
              } else {
                if (data.BLLinerData.length > 0) {
                  this.amsFiligModal.clientName =
                    data.BLLinerData[0].clientName;
                  this.amsFiligModal.clientId = data.BLLinerData[0].clientId;
                }
                this.amsFiligModal.shipperAddrWithCtc =
                  data.BLLinerData[0].corporateAddress;
                this.amsFiligModal.loadingPort =
                  data.BLLinerData[0].corporateAddress;
                this.amsFiligModal.finalDeliveryWithZip =
                  data.BLLinerData[0].valFinal;
                this.amsFiligModal.dischargePort =
                  data.BLLinerData[0].valPodLocation;
                this.amsFiligModal.loadingPort = data.BLLinerData[0].valLP;
                this.amsMainModel.portLocationType =
                  data.BLLinerData[0].portLocationType;
              }
            }

            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    onFileChangelinerBL() {
 let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "moduleId",
          this.$sessionsStorage.get("editExportFCLId") 
        );
      
          formData.append("staticFileName", "Sea_Export_AMSFILING_BL");
        

        formData.append("upload_dir_folderName", "FF_Sea_Export_Uploads");
      } 

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then(result => {
            this.amsMainModel.uploadMasterBL = result.data;
        })
        .catch(err => {
          throw err;
        });
    
    },

    viewEditAms(item) {
      Object.keys(this.amsFiligModal).map((x, index) => {
        this.amsFiligModal[x] = item[x];
      });
    },

    validateAms() {
      let validate_new = true;
      Object.keys(this.erroramsMainModel).map((x, index) => {
        if (this.amsMainModel[x] == "") {
          this.erroramsMainModel[x] = this.arrayErroramsMainModel[x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addNormalFFAms(id) {
      this.amsMainModel["ExportId"] = this.$sessionsStorage.get(
        "editExportFCLId"
      );
      this.amsMainModel["ExecutionId"] = this.$sessionsStorage.get(
        "editFFExecutionId"
      );
      this.amsMainModel["BookingId"] = this.$sessionsStorage.get(
        "editFFBookingId"
      );

      let new_data = {
        amsMainModel: this.amsMainModel
      };

      if (id == "") {
        new_data["onlyExecMain"] = "";
      } else {
        new_data["onlyExecMain"] = "fczdfs";
      }

      if (this.amsMainModel.amsFiling == "Yes") {
        new_data["amsFiligModal"] = this.amsFiligModal;
      }

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addNormalFFAms.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.amsFiligModal.amsffNormalId != "") {
                this.alert.content = "Data updated Successfully";
                this.$refs["addPop"].open();
              } else {
                this.alert.content = "Data Added Successfully";
                this.$refs["addPop"].open();
              }

              if (id != "") {
                this.$router.push({
                  path: "/freightForwarding/normalIsfExport"
                });
              }

              this.getData();
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },

    previousSalesView() {
window.history.go(-1)
      // if (
      //   this.$sessionsStorage.get("blType") == "house" &&
      //   this.amsMainModel.portLocationType == "USA"
      // ) {
      //   this.$router.push({
      //     path: "/freightForward/BL-US"
      //   });
      // } else if (
      //   this.$sessionsStorage.get("blType") == "house" &&
      //   this.amsMainModel.portLocationType == "NON_USA"
      // ) {
      //   this.$router.push({
      //     path: "/freightForward/BL-NonUS"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/fclBLofLanding"
      //   });
      // }
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// amsFilingNormal.vue?1cc4a7f2